import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

type Props = {
  cardNumber: number;
  isOnDark: boolean;
};

const useStyles = makeStyles<Props>({
  name: 'Card',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  wrapper: {
    display: 'grid',
    gridAutoFlow: 'column',
    columnGap: spacing(2),
    gridTemplateColumns: `repeat(${props.cardNumber}, 100%)`,
  },
  wrapper2up: {
    [breakpoints.up('sm')]: {
      justifyContent: 'center',
      gridTemplateColumns: `repeat(2, minmax(200px, 384px))`,
    },
  },
  wrapper3up: {
    [breakpoints.up('md')]: {
      justifyContent: 'center',
      gridTemplateColumns: `repeat(3, minmax(200px, 384px))`,
    },
  },
  box: {
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue40,
      brandColors.white
    ),
    padding: `0 ${spacing(2)}`,

    '&:nth-child(5n)': {
      paddingBottom: spacing(2),
      borderBottomRightRadius: '16px',
      borderBottomLeftRadius: '16px',
    },
    '&:nth-child(5n+1)': {
      paddingTop: spacing(2),
      paddingBottom: spacing(-1),
      borderTopRightRadius: '16px',
      borderTopLeftRadius: '16px',
    },
  },
  card1: {
    gridColumn: 1,
  },
  card2: {
    gridColumn: 2,
  },
  card3: {
    gridColumn: 3,
  },
  item1: {
    gridRow: 1,
  },
  item2: {
    gridRow: 2,
  },
  item3: {
    gridRow: 3,
  },
  item4: {
    gridRow: 4,
  },
  item5: {
    gridRow: 5,
  },
  item6: {
    gridRow: 6,
  },
  title: {
    paddingBottom: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  subhead: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  listTitle: {
    paddingTop: spacing(-1),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  chipContainer: {
    minHeight: typography.pxToRem(64),
  },
  chip: {
    color: darkOrLightStyle(props)(
      brandColors.primaryDark,
      brandColors.heroYellow10
    ),
    backgroundColor: darkOrLightStyle(props)(
      brandColors.chargeBlue,
      brandColors.heroYellow
    ),
  },
  featuredList: {
    listStyle: 'none',
    paddingLeft: 0,
    '& svg': {
      marginRight: spacing(-1),
    },
    '& li': {
      paddingTop: spacing(-1),
      display: 'flex',
    },
  },
  bulletedList: {
    paddingLeft: '25px',
    '& li': {
      '&:not(:last-child)': {
        marginBottom: spacing(-1),
      },
    },
  },
  bulletedListTitle: {
    paddingBottom: spacing(-1),
  },
  list: {
    color: brandColors.tintsNeutral20,
    margin: `0  0 ${spacing(0)} 0`,
    '& li': {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
  },
  buttonContainer: {
    marginTop: spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    alignItems: 'end',
  },
  buttonInnerContainer: {
    display: 'flex',
    gap: spacing(-1),
  },
  secondListContainer: {
    marginTop: spacing(0),
  },
}));

export default useStyles;
